import axios from 'axios'
import { trackPromise } from 'react-promise-tracker'

export const saveClient = async (app, client) => {
    let save_client = null

    app.startLoadingIndicator("Saving client")
    if (!client._id)
        await trackPromise (
            axios.post(app.API_URI + '/clients', client)
            .then(async (result) => {
                save_client = result.data
                app.stopLoadingIndicator()
            })
            .catch(error => { app.errorLoadingIndicator(error) })
        )
    else {
        await trackPromise (
            //axios.post(app.API_URI + '/clients/save', client)
            axios.put(app.API_URI + `/clients?id=${client._id}`, client)
            .then(async (result) => {
                save_client = result.data
                app.stopLoadingIndicator()
            })
            .catch(error => { app.errorLoadingIndicator(error) })
        )
    }
    return save_client
}

export const saveClientUser = async (app, user) => {
    let updated_client = null

    app.startLoadingIndicator("Saving client")

    /** New User */
    if (!user.id)
        await trackPromise (
            //axios.post(app.API_URI + '/clients/user/save', user)
            axios.post(app.API_URI + '/clients/users', user)
            .then(async (result) => {
                updated_client = result.data // This data is the updated Client collection
                app.stopLoadingIndicator()
            })
            .catch(error => { app.errorLoadingIndicator(error) })
        )

    /** Update User */
    else
        await trackPromise (
            //axios.post(app.API_URI + '/clients/user/save', user)
            axios.put(app.API_URI + `/clients/users?user_id=${user.id}`, user)
            .then(async (result) => {
                updated_client = result.data // This data is the updated Client collection
                app.stopLoadingIndicator()
            })
            .catch(error => {
                app.errorLoadingIndicator(error)
            })
        )

    /** save_client is the updated Client not a Client's User */
    return updated_client
}

export const deleteClientUser = async (app, user_id) => {
    let delete_client_user = null

    app.startLoadingIndicator("Deleting Client's user")
    await trackPromise (
        axios.delete(app.API_URI + `/clients/users?user_id=${user_id}`)
        .then(async (result) => {
            delete_client_user = result.data
            app.stopLoadingIndicator()
        })
        .catch(error => { app.errorLoadingIndicator(error) })
    )
    return delete_client_user
}

/** This will return only the Client's Users list */
export const getClientUsers = async (app) => {
    let client_users = null

    app.startLoadingIndicator("Getting users list")
    await trackPromise (
        axios.get(app.API_URI + `/clients/users?client_id=${app.clientID}`)
        .then(async (result) => {
            client_users = result.data
            app.stopLoadingIndicator()
        })
        .catch(error => { app.errorLoadingIndicator(error) })
    )
    return client_users
}

export const updateClientSchedules = async (app, this_client) => {
    let update_cs = null

    app.startLoadingIndicator("Updating schedule")
    await trackPromise (
        //axios.post(app.API_URI + '/clients/schedules/update', this_client)
        axios.post(app.API_URI + `/clients/schedules?client_id=${this_client._id}`, this_client)
        .then(result => {
            update_cs = result.data
            app.stopLoadingIndicator()
        })
        .catch(error => { app.errorLoadingIndicator(error) })
    )
    return update_cs
  }